import { sidebarConstants } from "actions/types";
import type { SidebarState } from "types/state";

export const sidebar = (
  state: SidebarState = { showSidebar: false },
  action: { type: string }
): SidebarState => {
  switch (action.type) {
    case sidebarConstants.SIDEBAR_SHOW:
      return { ...state, showSidebar: true };
    case sidebarConstants.SIDEBAR_HIDE:
      return { ...state, showSidebar: false };
    default:
      return state;
  }
};
